<template>
  <section class="personalSchedule-section" :style="{ backgroundImage: `url(${profileConfig.bg})` }">
    <Header />
    <div class="personalSchedule-title">
      <router-link style="display: flex" :to="{ name: userProfile.personalScheduleProvider.name, params: { stream: userProfile.personalScheduleProvider.params.stream ? userProfile.personalScheduleProvider.params.stream : '' } }">
        <i class="fas fa-calendar-alt"></i>
      </router-link>
      <label>Agenda Pessoal</label>
    </div>
    <div class="personalSchedule-container" style="max-width: 780px" v-if="personalScheduleItems.length == 0">
      <span class="personalSchedule-preview-container" style="font-size: 1.6rem">
        Você ainda não adicionou nenhum item
        <router-link :to="{ name: userProfile.personalScheduleProvider.name, params: { stream: userProfile.personalScheduleProvider.params.stream ? userProfile.personalScheduleProvider.params.stream : '' } }">
          <button class="button">VISITE</button>
        </router-link>
      </span>
    </div>
    <div :key="updaterKey" class="personalSchedule-container" v-else>
      <div class="personalSchedule-preview-wrapper" v-if="selectedItem">
        <div class="personalSchedule-preview-container">
          <h2 v-html="selectedItem.title"></h2>
          <div style="cursor: pointer">
            <h3>{{ new Date(selectedItem.start_date).toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' }) }} - {{ new Date(selectedItem.finish_date).toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' }) }}</h3>
            <i class="fas fa-wifi" style="position: absolute; top: 20px; right: 0; font-size: 1.5rem; opacity: 0.5" v-if="isLive(selectedItem)"></i>
          </div>
          <span v-html="selectedItem.description"></span>
          <section class="preview-iframes-container">
            <img :src="parseActivityPoster(selectedItem.activity_id, selectedItem.config.image)" />
          </section>

          <button class="button" @click="openLink(selectedItem.links)" v-if="isLive(selectedItem)">ENTRAR</button>

          <!-- <router-link class="button" :to="selectedItem.links" v-if="selectedItem.links.name && isLive(selectedItem)">ENTRAR</router-link>
          <router-link class="button" :to="{name:'Conference',params:{stream:selectedItem.activity.activity_id}}" v-if="usesZoomIntegration(selectedItem.links) && !selectedItem.links.name && isLive(selectedItem)">ENTRAR</router-link> -->
        </div>
      </div>
      <div class="personalSchedule-list-wrapper" v-if="selectedItem">
        <div class="personalSchedule-list-item-container" v-for="group in groups" :key="group.id" v-show="personalScheduleItems.filter((i) => i.config.group == group.id).length != 0">
          <span class="personalSchedule-list-header-container" @click="group.collapsed = !group.collapsed">
            <span style="all: unset">
              <label style="cursor: pointer" v-if="personalScheduleItems.filter((i) => i.config.group == group.id).length != 0">{{ parsedGroupTitle(group.title) }}</label>
            </span>
            <i class="fas fa-caret-square-down" style="margin: 0 10px 0 auto" v-if="group.collapsed"></i>
            <i class="far fa-caret-square-up" style="margin: 0 10px 0 auto" v-if="!group.collapsed"></i>
          </span>
          <div class="personalSchedule-draggable-wrapper" :style="{ height: group.collapsed ? '110px' : 'auto' }">
            <div style="display: flex; width: 100%" v-for="item in personalScheduleItems" :key="item.schedule_id" @click.prevent="itemClicked(item)">
              <div class="personalSchedule-item-container" :class="{ selected: item.schedule_id == selectedItem.schedule_id }" v-if="item.config.group == group.id">
                <div class="personalSchedule-item-datetime">
                  <div>{{ new Date(item.start_date).toLocaleDateString('pt-BR', { weekday: 'short', day: 'numeric' }) }}</div>
                  <div>{{ new Date(item.start_date).toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' }) }}</div>
                  <div>{{ new Date(item.finish_date).toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' }) }}</div>
                  <!-- <div>{{new Date(item.finish_date).toLocaleDateString('pt-BR', {weekday: 'short',  day: 'numeric' })}}</div>  -->
                </div>
                <div class="personalSchedule-item-txts">
                  <!-- <h2 v-html="item.title"></h2> -->
                  <h3>{{ parsedActivityTitle(item.activity_id) }}</h3>
                  <span v-html="item.description"></span>
                </div>
                <i class="fas fa-wifi personalSchedule-item-onair" v-if="isLive(item)"></i>
                <div class="personalSchedule-item-btns" @click.prevent="apiDeletePersonalSchedule(item)">
                  <i class="far fa-trash-alt" v-if="!item.isDeleting"></i>
                  <SpinnerButton v-else />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer style="position: fixed" />
    <Spinner style="padding-top: 23%" :showSpinner="showSpinner" />
  </section>
</template>

<script>
import Header from '@/components/general/Header.vue';
import Footer from '@/components/general/Footer.vue';
import SpinnerButton from '@/components/ui/SpinnerButton.vue';
import Spinner from '@/components/ui/Spinner.vue';
import api from '@/services/api';
import * as dayjs from 'dayjs';
import draggable from 'vuedraggable';

export default {
  name: 'PersonalSchedule',
  components: { Header, Footer, draggable, SpinnerButton, Spinner },

  data() {
    return {
      dayjs: null,
      activities: [],
      personalScheduleItems: [{}],
      personalScheduleItemsMatched: null,
      profileConfig: null,
      userProfile: null,
      selectedItem: null,
      isReordering: false,
      groups: null,
      personalScheduleProviderActivity: { name: 'Network', params: { stream: null } },
      showSpinner: false,
      updaterInterval: null,
      psKey: '',
      usesZoom: false,
      updaterKey: '',
    };
  },

  computed: {
    selectedActivity() {
      return this.selectedItem.activity_id;
    },
  },
  methods: {
    apiGetPersonalSchedule(isReload) {
      api
        .get(`event/${this.$store.state.eventId}/schedule?user_id=${this.$store.state.user.id}`)
        .then((response) => {
          // console.log('get personalSchedule response: ', { response });
          this.personalScheduleItems = response.data.map((item) => {
            item.isDeleting = false;
            item.config = JSON.parse(item.config);
            item.activity = this.activities.filter((act) => act.activity_id == item.activity_id)[0];

            if (!item.activity) item.activity = this.activities[0];

            if (item.activity.activity_type)
              item.links =
                item.activity.activity_type == 'Conference'
                  ? JSON.parse(item.activity.property).meetLink
                  : item.activity.activity_type == 'RouterCard'
                  ? { name: JSON.parse(item.activity.property).src, params: { stream: JSON.parse(item.activity.property).stream } }
                  : { name: item.activity.activity_type, params: { stream: item.activity_id } };

            if (item.config.class == 'card') {
              let filtered = this.activities.filter((act) => act.activity_id == item.activity_id);
              // console.log('response.data.map: ', item.activity_id, filtered);
              if (filtered[0]) {
                item.title = filtered[0].activity ? filtered[0].activity : '';
                item.description = filtered[0].description ? filtered[0].description : '';
                item.start_date = filtered[0].date_start ? filtered[0].date_start : new Date();
                item.finish_date = filtered[0].date_finish ? filtered[0].date_finish : new Date();
              }
            }
            return item;
          });

          this.groups = [...new Set(this.personalScheduleItems.map((item) => item.config.group))];
          this.groups = this.groups.map((item) => ({ id: item, title: item, group: item, collapsed: false }));
          this.groups.sort((a, b) => a.title.localeCompare(b.title));
          try {
            this.personalScheduleItems.sort((a, b) => {
              return a.start_date.localeCompare(b.start_date);
            });
          } catch (e) {
            console.warn('Inconsistent date format on start_date', e);
          }

          this.personalScheduleItems = this.personalScheduleItems.filter((item) => !this.isPast(item.finish_date));

          if (isReload) {
            let temp = this.selectedItem;
            this.selectedItem = this.personalScheduleItems.filter((item) => item.activity_id == temp.activity_id)[0];
            setTimeout(() => {
              this.showSpinner = false;
            }, 400);
          } else {
            this.selectedItem = this.personalScheduleItems[0];
            setTimeout(() => {
              this.showSpinner = false;
            }, 400);
          }
        })
        .catch((err) => {
          this.showSpinner = false;
          console.error(err);
        });
    },
    apiPutPersonalSchedule(item) {
      let payload = {
        item: item.item,
        order: item.order,
        properties: JSON.stringify(item.properties),
      };
      api
        .put(`event/${this.$store.state.eventId}/schedule/${item.schedule_id}`, payload)
        .then((response) => {
          // console.log('put personalSchedule response: ', item.order, { response });
        })
        .catch((err) => console.error(err));
    },
    apiDeletePersonalSchedule(item) {
      item.isDeleting = true;

      if (confirm('Remover item?')) {
        api
          .delete(`event/${this.$store.state.eventId}/schedule/${item.schedule_id}`)
          .then((response) => {
            item.isDeleting = false;
            this.personalScheduleItems = this.personalScheduleItems.filter((i) => i.schedule_id != item.schedule_id);
          })
          .catch((err) => console.error(err));
      } else item.isDeleting = false;
    },
    apiGetActivities() {
      api
        .get(`event/${this.$store.state.eventId}/activities`)
        .then((response) => {
          // console.log('apiGetActivities', { response });
          this.activities = response.data;
          this.apiGetPersonalSchedule(true);
        })
        .catch((err) => {
          console.error(err);
        });
    },
    itemClicked(item) {
      this.selectedItem = item;
    },
    parsedGroupTitle(title) {
      return title;
      let activityTitle = this.activities.filter((act) => act.activity_id == title)[0];
      if (activityTitle) activityTitle = activityTitle.activity;
      return activityTitle ? activityTitle : title;
    },
    parsedActivityTitle(title) {
      let activityTitle = this.activities.filter((act) => act.activity_id == title)[0];
      if (activityTitle) activityTitle = activityTitle.activity;
      return activityTitle ? activityTitle : title;
    },
    parseActivityPoster(id, image) {
      let activity = this.activities.filter((act) => act.activity_id == id)[0];
      let fallback = activity ? JSON.parse(activity.images).poster : '';
      return image ? image : fallback;
    },
    isLive(item) {
      if (item) {
        let startDate = new Date(item.start_date);
        let finishDate = new Date(item.finish_date);
        let today = new Date();
        // console.log('isLive', today, startDate);

        return Date.parse(startDate) <= Date.parse(today) && Date.parse(finishDate) > Date.parse(today);
      } else return false;
    },
    isPast(date) {
      let finishDate = new Date(date);
      const today = new Date();
      return Date.parse(finishDate) < Date.parse(today);
    },
    apiGetMatchedActivities(isReload) {
      if (!isReload) this.showSpinner = true;
      api
        .get(`event/${this.$store.state.eventId}/schedule?user_id=${this.$store.state.user.id}`)
        .then((response) => {
          // console.log('apiGetMatchedActivities', { response });
          if (!response.data.length) this.apiGetPersonalSchedule();
          this.personalScheduleItemsMatched = response.data;
          const parsed = this.personalScheduleItemsMatched.map(async (item) => {
            if (!item.activity_id) item.activity_id = '314a2460-43bb-11eb-bda6-a37b5e22abbb';
            const activity = await api.get(`event/${this.$store.state.eventId}/activity/${item.activity_id}`);
            this.activities.push(activity.data);
            // this.activities = [...new Set(this.activities)];
            // console.log('this.activities', this.activities);
            if (parsed.length == this.activities.length) this.apiGetPersonalSchedule(isReload);
            return item;
          });
        })
        .catch((err) => {
          console.error(err);
        });
    },
    usesZoomIntegration(url) {
      if (typeof url === 'string') {
        if (this.$store.state.template.useZoomIntegration && url.includes('zoom')) return true;
        else return false;
      } else return false;
    },
    openLink(link) {
      // console.log({ link });
      let property = JSON.parse(this.selectedItem.activity.property);
      let openLinkInNewTab = property.openLinkInNewTab;

      // ZOOM INTEGRATION
      if (typeof link == 'string' && link.startsWith('http') && link.includes('zoom.')) {
        if (openLinkInNewTab) this.usesZoom ? this.$router.push({ name: 'Conference', params: { stream: this.selectedItem.activity.activity_id } }) : window.open(link, '_blank');
        else this.usesZoom ? this.$router.push({ name: 'Conference', params: { stream: this.selectedItem.activity.activity_id } }) : window.open(link, '_parent');

        // URL
      } else if (typeof link == 'string' && link.startsWith('http')) {
        if (openLinkInNewTab) window.open(link, '_blank');
        else window.open(link, '_parent');

        // ACTIVITY ROUTE
      } else {
        try {
          let obj = typeof link == 'string' ? JSON.parse(link) : link;
          if (openLinkInNewTab) {
            let routeData = this.$router.resolve({ name: obj.name, params: { stream: obj.params.stream } });
            window.open(routeData.href, '_blank');
          } else {
            this.$router
              .push({
                name: obj.name,
                params: { stream: obj.params.stream },
              })
              .catch((err) => {
                console.error('navigation error', err);
              });
          }
        } catch (err) {
          console.error('navigation error', err);
        }
      }
    },
  },

  beforeMount() {
    this.updaterKey = this.$RNG.randomID();
    this.dayjs = dayjs;
    this.profileConfig = this.$store.state.template.profileConfig;
    this.userProfile = this.$store.state.template.userProfile;
    this.usesZoom = this.$store.state.template.useZoomIntegration;
    // this.apiGetActivities();
    this.apiGetMatchedActivities();
  },
  mounted() {
    this.updaterInterval = setInterval(() => {
      // this.apiGetActivities();
      this.updaterKey = this.$RNG.randomID();
      // console.log('update');
    }, 10000);
  },
  beforeDestroy() {
    clearInterval(this.updaterInterval);
  },
};
</script>

<style lang="scss">
.personalSchedule-section {
  position: relative;
  color: var(--userProfile-textColor);
  background-color: var(--main-color);
  background-position: center;
  background-size: cover;
  background-attachment: fixed;
  background-repeat: repeat-y;
  width: 100%;
  height: 100%;
  min-height: calc(100dvh);
  padding-top: 106px;

  display: flex;
  flex-direction: column;

  @include media('<=phone') {
    padding: 62px 0;
  }
}
.personalSchedule-title {
  position: relative;
  width: max-content;
  font-size: 3rem;
  text-align: left;
  margin-left: 11%;
  padding: 6px 16px 6px 6px;
  border-radius: var(--userProfile-borderRadius);
  filter: brightness(0.8);
  background: #111;
  @supports ((-webkit-backdrop-filter: none) or (backdrop-filter: none)) {
    background: none;
    -webkit-backdrop-filter: brightness(100%) blur(40px);
    backdrop-filter: brightness(100%) blur(40px);
  }

  @include media('<=tablet') {
    margin-left: 30px;
  }
  @media (max-width: 860px) {
    margin-left: 20px;
  }
  @include media('<=phone') {
    margin-left: 2.3%;
  }
  display: flex;
  align-items: center;
  i {
    color: var(--userProfile-textColor);
    font-size: 2.3rem;
    margin-right: 10px;
    @include media('<=phone') {
      font-size: 2rem;
    }
  }
  label {
    font-size: 3rem;
    @include media('<=phone') {
      font-size: 2.3rem;
    }
  }
}
.personalSchedule-container {
  position: relative;
  padding: 0 10% 120px 10%;

  display: flex;
  flex-wrap: wrap;
  flex-direction: row-reverse;
  align-items: flex-start;
  justify-content: flex-start;

  @include media('<=tablet') {
    padding: 1% 2%;
  }
  @media (max-width: 860px) {
    flex-direction: column-reverse;
    padding: 1% 2% 120px;
  }
  @include media('<=phone') {
    padding: 1% 0px;
  }
}
.personalSchedule-preview-wrapper {
  position: relative;
  width: 40%;
  min-height: 260px;
  flex-grow: 1;
  border-radius: var(--userProfile-borderRadius);
  border-top-left-radius: unset;
  border-bottom-left-radius: unset;
  padding: 1.5% 2%;

  display: flex;
  flex-wrap: wrap;

  background: #111;
  @supports ((-webkit-backdrop-filter: none) or (backdrop-filter: none)) {
    background: none;
    -webkit-backdrop-filter: brightness(100%) blur(40px);
    backdrop-filter: brightness(100%) blur(40px);
  }
  @media (max-width: 860px) {
    width: 100%;
    padding: 20px;
    border-top-left-radius: var(--userProfile-borderRadius);
    border-bottom-right-radius: unset;
  }
}
.personalSchedule-preview-container {
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;

  h2 {
    position: relative;
    margin-bottom: 6px;
    font-size: 2rem;
    overflow: hidden;
    text-overflow: ellipsis;
    // text-transform: capitalize;
  }
  h3 {
    position: relative;
    font-size: 1.3rem;
    margin-bottom: 10px;
    filter: brightness(0.7);
  }
  span {
    position: relative;
    margin-bottom: 12px;
    overflow-x: hidden;
    text-overflow: ellipsis;
    max-height: 100px;
  }

  img {
    position: relative;
    max-width: 100%;
    max-height: 400px;
    object-fit: contain;
    @include media('<=phone') {
      height: 200px;
    }
  }
  button,
  .button {
    cursor: pointer;
    position: relative;
    width: 100%;
    margin-top: 20px;
    padding: 10px;
    color: var(--userProfile-textColor);
    background: var(--userProfile-buttonBgColor);
    border-radius: calc(var(--userProfile-borderRadius) / 2);
    text-align: center;

    @include media('<=phone') {
      margin: 16px 0 0;
    }
  }
  .preview-iframes-container {
    position: relative;
    width: 100%;
    .pdf-iframe {
      position: relative;
      width: 100%;
      flex-grow: 1;
      height: 47vh;
      margin-top: 10px;
    }
    .video-iframe {
      position: relative;
      width: 100%;
      height: calc(20vw);
      margin-top: 10px;
      padding: 0;
      @include media('<=tablet') {
        height: 400px;
      }
      @include media('<=phone') {
        height: 200px;
      }
    }
    img {
      width: 100%;
    }
  }
}
.personalSchedule-list-wrapper {
  position: relative;
  width: 60%;
  flex-grow: 1;
  max-height: calc(92vh - 240px);
  padding: 1.5% 2%;
  overflow-y: auto;
  overflow-x: hidden;
  user-select: none;
  border-radius: var(--userProfile-borderRadius);
  border-top-right-radius: unset;
  background: #111;
  @supports ((-webkit-backdrop-filter: none) or (backdrop-filter: none)) {
    background: none;
    -webkit-backdrop-filter: brightness(100%) blur(40px);
    backdrop-filter: brightness(100%) blur(40px);
  }

  @media (max-width: 860px) {
    width: 100%;
    padding: 14px;
    border-top-right-radius: var(--userProfile-borderRadius);
  }
  @include media('<=phone') {
    padding: 8px 12px;
  }

  &::-webkit-scrollbar {
    background-color: transparent;
    width: 0px;
  }
}
.personalSchedule-list-item-container {
  position: relative;
  margin-bottom: 30px;
  // padding: 10px;
  // background: #111a;
  // &:nth-child(odd) {
  //   background: #000a;
  // }
  @include media('<=phone') {
    // max-width: 42vw;
    margin-bottom: 6px;
  }
}
.personalSchedule-list-header-container {
  position: relative;
  width: 100%;
  margin-bottom: 8px;
  color: var(--userProfile-textColor);
  background: none;
  font-size: 1.6rem;
  text-align: left;
  border: none;
  cursor: pointer;
  display: flex;

  filter: brightness(0.8);

  i {
    filter: brightness(0.7);
  }
}
.personalSchedule-draggable-wrapper {
  position: relative;
  overflow-y: scroll;
  display: flex;
  flex-wrap: wrap;

  &::-webkit-scrollbar {
    background-color: transparent;
    width: 10px;
  }
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  &::-webkit-scrollbar-thumb {
    display: none;
    &:hover {
      display: block;
    }
  }
}
.personalSchedule-item-container.selected {
  background: var(--userProfile-buttonBgColor);
  color: var(--userProfile-buttonTextColor);
  // filter: hue-rotate(180deg);

  .handle {
    filter: brightness(1);
  }
  .personalSchedule-item-btns i {
    filter: brightness(1);
  }
}
.personalSchedule-item-container {
  cursor: pointer;
  position: relative;
  width: 100%;
  padding: 10px 16px 10px 14px;
  margin: 0 0 10px;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  background: var(--userProfile-middleBgColor);
  border-radius: calc(var(--userProfile-borderRadius) / 2);
  &:active {
    transform: scale(0.99);
  }

  @include media('<=phone') {
    min-height: unset;
    max-height: 60px;
    margin: 0 0 10px;
    padding: 4px 14px;
    overflow: hidden;
  }

  img {
    position: relative;
    width: 100px;
    max-height: 100px;
    margin: 0 16px 0 0;
    object-fit: contain;
    object-position: top;
    // border-radius: 50%;
  }
  .personalSchedule-item-datetime {
    position: relative;
    height: 100%;
    padding: 0 10px 0 0;
    margin-right: 10px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    font-size: 1.1rem;
    filter: brightness(0.85);

    @include media('<=phone') {
      // max-width: 42vw;
      font-size: 1rem;
    }

    div:nth-child(1) {
      margin-bottom: 4px;
      font-size: 0.8rem;
      opacity: 0.8;
      @include media('<=phone') {
        margin-bottom: 0px;
      }
    }
    div:nth-child(3) {
      margin-top: 2px;
      text-decoration: overline;
    }
  }
  .personalSchedule-item-txts {
    position: relative;
    display: flex;
    flex-wrap: wrap;

    @include media('<=phone') {
      max-width: calc(100vw - 150px);
      font-size: 1rem;
      height: 100%;
      display: flex;
      align-items: center;
    }
    h2 {
      position: relative;
      width: 100%;
      // text-transform: capitalize;
      overflow: hidden;

      @include media('<=phone') {
        text-overflow: ellipsis;
        white-space: nowrap;
        font-size: 1.2rem;
      }
    }
    h3 {
      position: relative;
      font-size: 1.55rem;
      margin-bottom: 4px;
      // filter: brightness(1);
      @include media('<=phone') {
        text-overflow: ellipsis;
        white-space: nowrap;
        font-size: 1.2rem;
      }
    }
    span {
      position: relative;
      width: 100%;
      filter: brightness(0.9);
      @include media('<=phone') {
        display: none;
      }
    }
  }
  .personalSchedule-item-onair {
    position: absolute;
    top: 28px;
    right: 60px;
    font-size: 1.5rem;
    opacity: 0.5;
    @include media('<=phone') {
      top: 13px;
    }
  }
  .personalSchedule-item-btns {
    position: relative;
    height: 100%;
    margin-left: auto;
    display: flex;
    align-items: center;
    transition: all 200ms ease-in-out;
    i {
      filter: brightness(0.6);

      &:hover {
        transform: scale(1.3);
        filter: brightness(1);
      }
    }
  }
  .handle {
    position: relative;
    font-size: 24px;
    margin: auto 4px auto 14px;
    transition: all 100ms ease-in-out;
    transform: scaleY(1.1);
    filter: brightness(0.6);
    &:hover {
      transform: scale(1.3);
      filter: brightness(1);
    }
  }
}
</style>
